import { useEffect, useState } from 'react';

/** Returns a boolean value that turns from false to true after specified timeout */
export function useDelay(ms: number) {
    const [passed, setPassed] = useState(false);

    useEffect(() => {
        const handle = setTimeout(() => setPassed(true), ms);
        return () => {
            clearTimeout(handle);
        };
    }, [ms]);

    return passed;
}
